<template>
  <div class="home">
    <banner />
    <section class="container">
      <div class="textEnergy">
        <h3>Digital Energy, Smart Storage For The Future</h3>
        <p class="enerIcon"><img :src="$t('homepage.enimg')" alt="" /></p>
        <h4>{{ $t('homepage.text0') }}</h4>
        <p class="art_item">
          {{ $t('homepage.text1') }}
        </p>
      </div>
      <powerList />
      <section class="carousel"><carousel_images /></section>
      <section class="carousel"><carousel /></section>
      <advantage />
    </section>
  </div>
</template>

<script>
// @ is an alias to /src

import banner from '@/components/banner.vue';
import powerList from '@/components/powerList.vue';
import carousel from '@/components/carousel.vue';
import carousel_images from '@/components/carousel_Images.vue';
import advantage from '@/components/advantage.vue';
export default {
  name: 'HomeView',
  components: {
    banner,
    powerList,
    carousel_images,
    carousel,
    advantage,
  },
};
</script>
<style lang="scss" scoped>
.art_item {
  padding: 1rem 0;
  color: #908f8d;
}
.textEnergy {
  padding: 1.2rem;
}
h3 {
  font-size: 18px;
}
h3,
h4 {
  font-size: 18px;
}
.enerIcon {
  padding: 1rem 0;
}
.carousel {
  margin: 20px 0 0 0;
}
</style>
